import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Provider from '@solvhealth/types/interfaces/Provider';
import { defaultProviderStatus } from '../../../ducks/providerGroups';
import { FETCH_PROVIDER } from '../../../sagas/providerGroups';
import { ProviderStatus } from '../interfaces';
import { useSolvSelector } from '../../../reducers';

const useFetchSingleProvider = (providerId?: string) => {
  const dispatch = useDispatch();

  const provider = useSolvSelector(
    (state) => (providerId && state.providerGroups.providers?.[providerId]) || undefined
  );

  const providerSlots = useSolvSelector(
    (state) => (providerId && state.providerGroups.slots[providerId]) || undefined
  );

  const providerStatus = useSolvSelector(
    (state): ProviderStatus =>
      (providerId && state.providerGroups.providerStatuses?.[providerId]) || defaultProviderStatus
  );

  const { loading, loadingExternal, errorExternal, error } = providerStatus;

  useEffect(() => {
    // we bail out here so we don't pollute the action queue unnecessarily
    if (
      providerId &&
      !(provider && providerSlots) &&
      !(loading || loadingExternal || errorExternal || error)
    ) {
      dispatch({
        type: FETCH_PROVIDER,
        providerId,
      });
    }
  }, [
    dispatch,
    providerId,
    provider,
    loading,
    error,
    errorExternal,
    providerSlots,
    loadingExternal,
  ]);

  return { provider, loading, loadingExternal, error, errorExternal, providerSlots };
};

export default useFetchSingleProvider;
